import { passengerTitles } from '../constants/Enums';

const useTextTitles = (returnSelect = true) => {
  const titles = [];

  if (returnSelect) {
    titles.push({
      label: passengerTitles.TITLE,
      value: '',
    });
  }

  titles.push(
    {
      label: passengerTitles.MR,
      value: passengerTitles.MR,
    },
    {
      label: passengerTitles.MRS,
      value: passengerTitles.MRS,
    },
    {
      label: passengerTitles.MS,
      value: passengerTitles.MS,
    },
    {
      label: passengerTitles.MISS,
      value: passengerTitles.MISS,
    },
    {
      label: passengerTitles.MSTR,
      value: passengerTitles.MSTR,
    },
    {
      label: passengerTitles.MILE,
      value: passengerTitles.MILE,
    },
    {
      label: passengerTitles.DR,
      value: passengerTitles.DR,
    },
    {
      label: passengerTitles.SIR,
      value: passengerTitles.SIR,
    },
    {
      label: passengerTitles.FATHER,
      value: passengerTitles.FATHER,
    },
    {
      label: passengerTitles.SISTER,
      value: passengerTitles.SISTER,
    },
    {
      label: passengerTitles.BROTHER,
      value: passengerTitles.BROTHER,
    },
    {
      label: passengerTitles.LT,
      value: passengerTitles.LT,
    },
    {
      label: passengerTitles.CAPT,
      value: passengerTitles.CAPT,
    },
    {
      label: passengerTitles.PROF,
      value: passengerTitles.PROF,
    },
    {
      label: passengerTitles.DUKE,
      value: passengerTitles.DUKE,
    },
    {
      label: passengerTitles.CONGRESSMAN,
      value: passengerTitles.CONGRESSMAN,
    },
    {
      label: passengerTitles.DUCHESS,
      value: passengerTitles.DUCHESS,
    },
    {
      label: passengerTitles.REV,
      value: passengerTitles.REV,
    },
    {
      label: passengerTitles.RT_HON,
      value: passengerTitles.RT_HON,
    },
    {
      label: passengerTitles.ST,
      value: passengerTitles.ST,
    }
  );
  return [titles];
};

export default useTextTitles;
